import { render, staticRenderFns } from "./childManage.vue?vue&type=template&id=473641d1&scoped=true&"
import script from "./childManage.vue?vue&type=script&lang=js&"
export * from "./childManage.vue?vue&type=script&lang=js&"
import style0 from "./childManage.vue?vue&type=style&index=0&id=473641d1&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "473641d1",
  null
  
)

export default component.exports